import loadScript from './utils/load-script';
import getAncestor from './utils/get-ancestor';

let config = {
    loadedClass: 'lazy-loaded',
    selector: '[data-src],[data-style],.lazy',
    scriptClickSelector: '[data-load-script]',
    scriptLoadingClass: 'script-loading',
    rootMargin: '50px 0px', // If the element gets within 50px in the Y axis, start the download.
    threshold: 0.01
}

let userInteractions = ["keydown", "mousemove", "wheel", "touchmove", "touchstart", "touchend"];
let elements = document.querySelectorAll(config.selector);
let elementCount = elements.length;
let observer = null;
let lazyScriptsLoaded = false;
let lazyLoadTimeout = null;

function init() {

    loadLazyStyles();
    initLazyScripts();

    // If we don't have support for intersection observer, loads the elements immediately
    if (!('IntersectionObserver' in window)) {
        loadImmediately(elements);
    } else {
        // It is supported, load the elements
        observer = new IntersectionObserver((entries) => onIntersection(entries), config);

        for (let i = 0; i < elements.length; i++) {
            let element = elements[i];
            if (element.classList.contains(config.loadedClass)) {
                elementCount--;
                continue;
            }
            observer.observe(element);
        }
    }
}

function loadLazyStyles() {
    let styles = window.lazyStyles || [];
    let head = document.getElementsByTagName('head')[0];

    for (let i = 0; i < styles.length; ++i) {
        var link = document.createElement('link');
        link.href = styles[i];
        link.rel = "stylesheet";
        head.appendChild(link);
    }
}

function initLazyScripts() {
    // Scripts that are loaded on specific clicks
    if (document.querySelector(config.scriptClickSelector)) {
        document.addEventListener('click', scriptLoadHandler, true);
    }

    // Scripts that are loaded on 1st user interaction
    if ((window.lazyScripts || []).length > 0) {
        if ((window.location.search || '').indexOf('nolazy') > -1) {
            console.log('Not lazy loading due to query string');
            loadLazyScripts();
        } else if (isTouchSafari()) {
            console.log('Not lazy loading due to being Safari on a touch device');
            loadLazyScripts();
        } else {
            for (var i = 0; i < userInteractions.length; i++) {
                window.addEventListener(userInteractions[i], loadLazyScripts, { passive: true });
            }
            // If no interaction after 10 seconds, load them anyway. This shouldn't affect performance
            lazyLoadTimeout = setTimeout(loadLazyScripts, 10000);
        }
    }
}

function loadLazyScripts() {

    if (lazyScriptsLoaded) {
        return;
    }

    lazyScriptsLoaded = true;
    var scripts = window.lazyScripts || [];

    for (var i = 0; i < scripts.length; i++) {
        let src = scripts[i];
        if (typeof src === 'string') {
            loadScript(src);
        } else {
            src();
        }
    }

    clearTimeout(lazyLoadTimeout);
}

/**
 * Event handler for when 'load script' elements are clicked
 */
function scriptLoadHandler(e) {

    var el = getAncestor(e.target, config.scriptClickSelector);

    if (!el) {
        return;
    }

    e.preventDefault();
    var src = el.dataset.loadScript;

    if (src && !el.classList.contains(config.scriptLoadingClass)) {

        el.classList.add(config.scriptLoadingClass);

        loadScript(el.dataset.loadScript).then(() => {

            el.classList.remove(config.scriptLoadingClass);
            el.classList.add('script-loaded');

            var type = el.dataset.loadScriptType || getDefaultTypeName(src);
            if (type && window[type]) {

                var instance = new window[type]();
                var method = el.dataset.loadScriptMethod;

                if (method) {
                    instance[method](el);
                }
            } else {
                console.error('Could not find type "' + type + '"');
            }

        }).catch((e) => {

            console.error(e);
            el.classList.remove(config.scriptLoadingClass);

        });
    }
}

/**
 * Used to assume a default type name that a script would provide. Eg. '/assets/js/my-script.js' => 'MyScript'
 */
function getDefaultTypeName(src) {
    return src.split('/').pop().split('.').shift().replace(/^.|[-_\s]+./g, function(x) {
        return x.replace(/[-_\s]+/g, '').toUpperCase();
    });
}

/**
 * Loads all of the elements immediately
 */
function loadImmediately(elements) {
    for (let i = 0; i < elements.length; i++) {
        loadElement(elements[i]);
    }
}

/**
 * Loads a single element
 */
function loadElement(el) {

    // Check if already loaded
    if (el.classList.contains(config.loadedClass)) {
        return;
    }

    if ( el.dataset.style ) {
        el.style = el.dataset.style;
    } else if ( el.dataset.src ) {
        el.src = el.dataset.src;
    }

    // Add the "loaded" class
    el.classList.add(config.loadedClass);
}

/**
 * Fires when observed elements come into view
 */
function onIntersection(entries) {

    // Disconnect if we've already loaded all of the elements
    if (elementCount === 0) {
        disconnect();
        return;
    }

    // Loop through the entries
    for (let i = 0; i < entries.length; i++) {

        let entry = entries[i];

        //  Stop watching and load the element if we are in viewport
        if (entry.intersectionRatio > 0) {
            elementCount--;
            observer.unobserve(entry.target);
            loadElement(entry.target);
        }
    }
}

function isTouchSafari() {
    let ua = (window.navigator.userAgent || '');
    return !/chrome|chromium|android/i.test(ua) && /safari/i.test(ua) && (('ontouchstart' in window) || navigator.maxTouchPoints > 0);
}

function disconnect() {
    if (observer) {
        observer.disconnect();
    }
}

init();

window.loadLazyElements = function(scope) {
    var elements = (scope || document).querySelectorAll(config.selector);
    loadImmediately(elements);
};

const  modulesToLoad = document.querySelectorAll('[data-sitmodule]');

let mdoulesLoaded = [];

modulesToLoad.forEach(async (e, i) => {
    if(!mdoulesLoaded.includes(e.dataset.sitmodule))
    {
        try{
            let module = await import('/assets/js/entries/' + e.dataset.sitmodule + ".js");
        }
        catch(e)
        {
            console.log(e);
        }
        mdoulesLoaded.push(e.dataset.sitmodule);
    }
   
});